<span
  class="info-icon material-icons-outlined"
  [attr.aria-expanded]="expanded ? 'true' : 'false'"
  aria-label="Show/Hide Info"
  iesIconButton
  (click)="onClick($event)"
  matTooltip="infoTooltip"
  [matTooltipDisabled]="!infoTooltip"
></span>
